// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3V5__","content":"Consent_content__2A1a_","footer":"Consent_footer__3iSKz"};